import { CSSResultGroup, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { ButtonElement } from 'elements/_shared/formElement.js'
import { style } from './caption-description.style.js'
import { classMap } from 'lit/directives/class-map.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


export const captionDescriptionAlignments = ['left', 'right'] as const
export type captionDescriptionAlignmentsType = typeof captionDescriptionAlignments

export const captionVariants = ['caption-s', 'caption-m', 'caption-l'] as const
export type captionVariantsType = typeof captionVariants

export const descriptionVariants = ['body-s', 'body'] as const
export type descriptionVariantsType = typeof descriptionVariants

@customElement('cse-caption-description')
export class CSECaptionDescription extends ButtonElement {
  static override styles: CSSResultGroup = [hostStyle, style, fontStyles]

  @property({ type: String, attribute: 'caption-variant' })
  captionVariant: captionVariantsType[number] = 'caption-s'

  @property({ type: String, attribute: 'description-variant' })
  descriptionVariant: descriptionVariantsType[number] = 'body-s'

  @property({ type: String })
  alignment: captionDescriptionAlignmentsType[number] = 'left'

  @property({ type: Boolean })
  inverted = false

  override render() {
    return html`
      <div
        class="${classMap({
          'cse-caption-description': true,
          'inverted': this.inverted,
          [`alignment-${this.alignment}`]: true,
        })}"
      >
        <slot name="caption" class="caption font-${this.captionVariant}"></slot>
        <slot class="description font-${this.descriptionVariant}"></slot>
      </div>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-caption-description': CSECaptionDescription
  }
}
